
import Swal from 'sweetalert2'


const Pay = () => {
    return (
        
          <>
            <h1 className="mt-5 pt-5 text-center">Payment system coming soon</h1>
          </>
       
    );
};

export default Pay;